<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-readonly': readOnly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readOnly }">{{
    label | translate
  }}</mat-label>
  <input
    readonly
    matInput
    [matDatepicker]="picker"
    [formControl]="control"
    [min]="minDate"
    [max]="maxDate"
    [matDatepickerFilter]="dateFilter"
  />
  <mat-datepicker-toggle
    matSuffix
    [for]="picker"
    [disabled]="readOnly"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker [disabled]="readOnly"></mat-datepicker>
  <mat-hint>DD/MM/YYYY</mat-hint>

  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ requiredLabel | translate }}
  </mat-error>
</mat-form-field>
